module.exports = __webpack_public_path__ + "img/m-banner-kfkmkuef-zh-TW.ac2f9e51.png";